// TODO: 정리
import { GET_CAMPAIGN_TEMPLATE_DATA } from "@/gql/campaign-template";
import { TempCampaign } from "@/types/campaign";
import { handleApolloError } from "@/utils/handle-form";
import { AndroidFilled, AppleFilled } from "@ant-design/icons";
import {
  DEFAULT_EVENT_OG_DESCRIPTION,
  DEFAULT_PROMOTION_OG_DESCRIPTION,
  DEFAULT_SURVEY_OG_DESCRIPTION,
  DEFUALT_OG_IMAGE_URL,
} from "@shared/common/constant/form";
import customCampaignTargetManager from "@shared/common/custom-target-condition";
import {
  ICampaignTargetCustom,
  TargetCustomCreationInfo,
} from "@shared/common/custom-target-condition/types";
import { geolocationTargetData } from "@shared/common/data/campaign-target-geolocation-data";
import { hasContent } from "@shared/common/node/document-helper";
import { INodeDevice } from "@shared/common/node/type";
import {
  ICampaignInput,
  ICampaignType,
  IGetCampaignTemplateDataQuery,
  IGetCampaignTemplateDataQueryVariables,
  IGetInsightCountQuery,
  ISiteStatCampaignType,
} from "@shared/common/types/api-private/generated/graphql";
import {
  Campaign,
  CampaignDisplayType,
  CampaignTargetType,
  CampaignTemplateData,
  CampaignType,
  ICampaignFilterV2,
  ICampaignTargetGroup,
  ICampaignTargetLoc,
  ICampaignTargetNewOrReturningVisitor,
  ICampaignTargetPage,
  ICampaignTargetUserAgent,
  PartialCampaign,
  TargetVersion,
} from "@shared/common/types/campaign";
import { DataSource } from "@shared/common/types/data-source";
import { ExternalSiteType } from "@shared/common/types/site";
import {
  createBannerCampaign,
  createBannerGroupCampaign,
  createChildPopupCampaign,
  createEmbeddedInstagramCampaignV2,
  createFormEventCampaign,
  createFormSurveyCampaign,
  createPopupCampaign,
  createPopupGroupCampaign,
  createPromotionCampaign,
} from "@shared/common/utils/create";
import { getParamValue, getUrlWithSchema } from "@shared/common/utils/url";
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInYears,
} from "date-fns";
import { t } from "i18next";
import moment from "moment";
import { NextRouter } from "next/router";
import { getPrivateApiClient } from "./apollo-client";
import {
  AndGroup,
  OrGroup,
  TargetByVersion,
  convertToLatest,
  latestVersion,
  removeEmptyTargetFields,
} from "./target-converter";
export { routerQuerySetter } from "@shared/common/utils/router-query-setter";

export const campaignTypeToString = (campaingType: CampaignType) => {
  if (campaingType === "POPUP") {
    return "POPUP";
  }

  return "";
};

export const getCdnImageUrl = (url: string) => {
  if (!url || url.startsWith("http")) {
    return url;
  } else {
    return `https://images.codenbutter.com${url}`;
  }
};

export const getResizedImageUrl = (url: string | unknown, d: string) => {
  if (String(url).indexOf("?") > -1) {
    return `${url}&d=${d}`;
  } else {
    return `${url}?d=${d}`;
  }
};

export const numberWithCommas = (x: number) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const nFormatter = (num: number, digits: number) => {
  const si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;
  for (i = si.length - 1; i > 0; i--) {
    // TODO: remove "as"
    if (num >= (si[i] as { value: number; symbol: string }).value) {
      break;
    }
  }
  // TODO: remove "as"
  return (
    (num / (si[i] as { value: number; symbol: string }).value)
      .toFixed(digits)
      .replace(rx, "$1") + (si[i] as { value: number; symbol: string }).symbol
  );
};

export const DATE_TIME_24HOUR_FORMAT = "YYYY.MM.DD HH:mm";

export const DATE_FORMAT = "YYYY.MM.DD";

export const formatDistanceToNowBear = (date: Date) => {
  if (differenceInYears(new Date(), date) > 0) {
    return `${differenceInYears(new Date(), date)}y`;
  } else if (differenceInMonths(new Date(), date)) {
    return `${differenceInMonths(new Date(), date)}M`;
  } else if (differenceInDays(new Date(), date)) {
    return `${differenceInDays(new Date(), date)}d`;
  } else if (differenceInHours(new Date(), date)) {
    return `${differenceInHours(new Date(), date)}h`;
  } else if (differenceInMinutes(new Date(), date)) {
    return `${differenceInMinutes(new Date(), date)}m`;
  }
  return "1m";
};

/** 상대경로 -> 절대경로로 변경 */
export const getAbsoluteUrl = (url: string, path: string) => {
  if (path.indexOf("//") === 0) {
    return getUrlWithSchema(`https:${path}`);
  } else if (path[0] === "/") {
    const urlObj = new URL(getUrlWithSchema(url));
    return `${urlObj.protocol}//${urlObj.host}${
      urlObj.port ? ":" + urlObj.port : ""
    }${path}`;
  } else if (path.indexOf("http") === -1) {
    return getUrlWithSchema(`${url}/${path}`);
  }

  return getUrlWithSchema(path);
};

/**
 *
 * @param noHostUrl host 가 없고 (URL 객체에 넘길 수 없는) pathname 과 searchParams 만 있는 URL 문자열
 * @returns URLSearchParams 객체
 */
export function convertNoHostUrlToSearchParams(
  noHostUrl: string
): URLSearchParams {
  const queryStringStartIndex = noHostUrl.indexOf("?");

  if (queryStringStartIndex === -1) {
    throw new Error("Invalid input string: Query string not found");
  }

  const queryString = noHostUrl.slice(queryStringStartIndex + 1);
  return new URLSearchParams(queryString);
}

export type TargetType = "ALL" | "PARTIAL" | "HOME";

export const getTargetType = (value?: CampaignTargetType): TargetType => {
  if (!value) {
    return "ALL";
  }

  const result = getPageAndUrlTargetList(value).map((item) => {
    if (item.type === "PAGE") {
      if (item.value === "HOME") {
        return "HOME";
      }

      return "PAGE";
    }

    if (item.type === "URL") {
      return "URL";
    }
  });

  if (result.length > 0) {
    if (result.length === 1 && result[0] === "HOME") {
      return "HOME";
    }
    return "PARTIAL";
  }

  return "ALL";
};

export const getTargetVersion = (
  value?: CampaignTargetType
): TargetVersion | "INVALID" => {
  if (value?.type === "OR") {
    return "1";
  }

  // Version 2 or higher
  else if (value?.type === "ROOT") {
    return value.version;
  }

  return "INVALID";
};

export const getDefaultTargetRoot = (
  info?: TargetCustomCreationInfo,
  defaultHome = true
): CampaignTargetType => {
  const result: TargetByVersion[typeof latestVersion] = {
    type: "ROOT",
    version: "7",
    value: {
      type: "AND",
      name: "ROOT",
      value: [
        {
          type: "OR",
          value: defaultHome ? [{ type: "PAGE", value: "HOME" }] : [],
          name: "PAGE_AND_URL_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "PAGE_AND_URL_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "USER_AGENT_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "USER_AGENT_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "OS",
        },
        {
          type: "OR",
          value: [],
          name: "DOMAIN_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "DOMAIN_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "REFERRER_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "REFERRER_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "LANGUAGE_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "LANGUAGE_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "UTM_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "UTM_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "GEOLOCATION_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "GEOLOCATION_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "LOCALSTORAGE_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "LOCALSTORAGE_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "SESSIONSTORAGE_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "SESSIONSTORAGE_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "COOKIE_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "COOKIE_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "QUERY_STRING_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "QUERY_STRING_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "IP_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "IP_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "HTML_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "HTML_NOT_INCLUDED",
        },
        {
          type: "OR",
          value: [],
          name: "NEW_OR_RETURNING_VISITOR_INCLUDED",
        },
        {
          type: "AND",
          value: [],
          name: "NEW_OR_RETURNING_VISITOR_NOT_INCLUDED",
        },
        ...(info ? customCampaignTargetManager.getDefaultValueList(info) : []),
      ],
    },
  };
  return result;
};

export const getDefaultTrigger = (): CampaignDisplayType => {
  const result: CampaignDisplayType = {
    type: "OR",
    value: [
      { type: "LAZY", value: 0 },
      { type: "EXIT_INTENT", value: "NONE" },
      { type: "SCROLL", value: { unit: "%", value: 0 } },
    ],
  };
  return result;
};

export const getEmptyTarget = (): CampaignTargetType => {
  const defaultTargetRoot = getDefaultTargetRoot() as TargetByVersion["6"];

  return removeEmptyTargetFields(defaultTargetRoot);
};

export const isAllPages = (target: CampaignTargetType) => {
  if (getTargetVersion(target) === "1" && target.type === "OR") {
    return target.value.length === 0 ? true : false;
  }

  if (
    target.type === "ROOT" &&
    target.version === "2" &&
    target.value.type === "AND"
  ) {
    const pageGroup = target.value.value.find(
      (item): item is ICampaignTargetGroup => item.type === "OR"
    );
    if (pageGroup && pageGroup.value.length === 0) {
      return true;
    }
  }
  return false;
};

export const getPageAndUrlIncludedTargetGroup = (
  target: CampaignTargetType
): ICampaignTargetGroup => {
  const targetVersion = getTargetVersion(target);

  if (targetVersion === "INVALID") {
    throw new Error("Invalid target");
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const pageGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is OrGroup<
      ICampaignTargetPage | ICampaignTargetLoc,
      "PAGE_AND_URL_INCLUDED"
    > => child.type === "OR" && child.name === "PAGE_AND_URL_INCLUDED"
  );

  if (!pageGroup) {
    throw new Error("pageGroup not found");
  }

  return pageGroup;
};

export const getPageAndUrlNotIncludedTargetGroup = (
  target: CampaignTargetType
): ICampaignTargetGroup => {
  const targetVersion = getTargetVersion(target);

  if (targetVersion === "INVALID") {
    throw new Error("Invalid target");
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const pageGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is AndGroup<ICampaignTargetLoc, "PAGE_AND_URL_NOT_INCLUDED"> =>
      child.type === "AND" && child.name === "PAGE_AND_URL_NOT_INCLUDED"
  );

  if (!pageGroup) {
    throw new Error("pageGroup not found");
  }

  return pageGroup;
};

export const flatCampaignTargetDeep = (
  group: ICampaignTargetGroup
): CampaignTargetType[] => {
  const result = group.value.map((item) => {
    if (item.type === "AND" || item.type === "OR") {
      return flatCampaignTargetDeep(item);
    }
    return item;
  });

  return result.flat();
};

export const getPageAndUrlTargetList = (
  target: CampaignTargetType
): CampaignTargetType[] => {
  try {
    const pageAndUrlgroupIncludedGroup =
      getPageAndUrlIncludedTargetGroup(target);
    const pageAndUrlgroupNotIncludedGroup =
      getPageAndUrlNotIncludedTargetGroup(target);

    return [
      ...flatCampaignTargetDeep(pageAndUrlgroupIncludedGroup),
      ...flatCampaignTargetDeep(pageAndUrlgroupNotIncludedGroup),
    ];
  } catch (e) {
    return [];
  }
};

export const getCustomTargetList = (
  target: CampaignTargetType
): ICampaignTargetCustom[] => {
  const targetVersion = getTargetVersion(target);
  if (targetVersion === "INVALID") {
    return [];
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const customTargets = latest?.value?.value?.filter?.(
    (child): child is ICampaignTargetCustom => child.type === "CUSTOM"
  );

  if (!customTargets) {
    return [];
  }

  return customTargets;
};

export const getUserAgentTargetList = (
  target: CampaignTargetType
): ICampaignTargetUserAgent[] => {
  const targetVersion = getTargetVersion(target);
  if (targetVersion === "INVALID") {
    return [];
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const userAgentIncludedGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is OrGroup<ICampaignTargetUserAgent, "USER_AGENT_INCLUDED"> =>
      child.type === "OR" && child.name === "USER_AGENT_INCLUDED"
  );

  const userAgentNotIncluedGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is AndGroup<ICampaignTargetUserAgent, "USER_AGENT_NOT_INCLUDED"> =>
      child.type === "AND" && child.name === "USER_AGENT_NOT_INCLUDED"
  );

  if (!userAgentIncludedGroup || !userAgentNotIncluedGroup) {
    return [];
  }

  return [...userAgentIncludedGroup.value, ...userAgentNotIncluedGroup.value];
};

export const getDomainTargetList = (
  target: CampaignTargetType
): ICampaignTargetLoc[] => {
  const targetVersion = getTargetVersion(target);
  if (targetVersion === "INVALID") {
    return [];
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const domainIncludedGroup = latest?.value?.value?.find?.(
    (child): child is OrGroup<ICampaignTargetLoc, "DOMAIN_INCLUDED"> =>
      child.type === "OR" && child.name === "DOMAIN_INCLUDED"
  );

  const domainNotIncludedGroup = latest?.value?.value?.find?.(
    (child): child is AndGroup<ICampaignTargetLoc, "DOMAIN_NOT_INCLUDED"> =>
      child.type === "AND" && child.name === "DOMAIN_NOT_INCLUDED"
  );

  if (!domainIncludedGroup || !domainNotIncludedGroup) {
    return [];
  }

  return [...domainIncludedGroup.value, ...domainNotIncludedGroup.value];
};

export const getConditionTargetList = (
  target: CampaignTargetType,
  value: string
) => {
  const targetVersion = getTargetVersion(target);
  if (targetVersion === "INVALID") {
    return [];
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const included = `${value}_INCLUDED`;
  const notIncluded = `${value}_NOT_INCLUDED`;

  const includedGroup = latest?.value?.value?.find?.(
    (child) => child.type === "OR" && child.name === included
  );

  const notIncludedGroup = latest?.value?.value?.find?.(
    (child) => child.type === "AND" && child.name === notIncluded
  );

  if (!includedGroup || !notIncludedGroup) {
    return [];
  }

  return [...includedGroup.value, ...notIncludedGroup.value];
};

export const getNewOrReturningVisitorTargetList = (
  target: CampaignTargetType
): ICampaignTargetNewOrReturningVisitor[] => {
  const targetVersion = getTargetVersion(target);
  if (targetVersion === "INVALID") {
    return [];
  }

  const latest = convertToLatest(
    target
  ) as TargetByVersion[typeof latestVersion];

  const newOrReturningVisitorIncludedGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is OrGroup<
      ICampaignTargetNewOrReturningVisitor,
      "NEW_OR_RETURNING_VISITOR_INCLUDED"
    > =>
      child.type === "OR" && child.name === "NEW_OR_RETURNING_VISITOR_INCLUDED"
  );

  const newOrReturningVisitorNotIncluedGroup = latest?.value?.value?.find?.(
    (
      child
    ): child is AndGroup<
      ICampaignTargetNewOrReturningVisitor,
      "NEW_OR_RETURNING_VISITOR_NOT_INCLUDED"
    > =>
      child.type === "AND" &&
      child.name === "NEW_OR_RETURNING_VISITOR_NOT_INCLUDED"
  );

  if (
    !newOrReturningVisitorIncludedGroup ||
    !newOrReturningVisitorNotIncluedGroup
  ) {
    return [];
  }

  return [
    ...newOrReturningVisitorIncludedGroup.value,
    ...newOrReturningVisitorNotIncluedGroup.value,
  ];
};

export const isValidPageQuery = (pageQuery: string | string[] | undefined) =>
  !Array.isArray(pageQuery) &&
  Boolean(pageQuery) &&
  Boolean(Number(pageQuery)) &&
  Number(pageQuery) > 0 &&
  Number(pageQuery) <= Number.MAX_SAFE_INTEGER;

export const getUserAgentPresets = () => {
  const userAgentPresets = [
    {
      name: "IOS",
      label: "editor:segment.target.panel.label.iOS.name",
      value: "like Mac OS",
      icon: <AppleFilled />,
    },
    {
      name: "ANDROID",
      label: "editor:segment.target.panel.label.android.name",
      value: "Android",
      icon: <AndroidFilled style={{ color: "#89ad0d" }} />,
    },
  ] as const;

  return userAgentPresets;
};

export const getReferrerPresets = () => {
  const referrerPresets = [
    {
      name: "NAVER",
      label: "NAVER",
      value: "naver",
      icon: <></>,
    },
    {
      name: "GOOGLE",
      label: "GOOGLE",
      value: "google",
      icon: <></>,
    },
    {
      name: "DAUM",
      label: "DAUM",
      value: "daum",
      icon: <></>,
    },
    {
      name: "FACEBOOK",
      label: "FACEBOOK",
      value: "facebook",
      icon: <></>,
    },
  ] as const;

  return referrerPresets;
};

export const getIsFirstPresets = () => {
  const referrerPresets = [
    {
      name: "NEW",
      label: "신규 방문자",
      value: "new",
      icon: <></>,
    },
    {
      name: "RETURNING",
      label: "재방문자",
      value: "returning",
      icon: <></>,
    },
  ] as const;

  return referrerPresets;
};

export const getNewOrReturningVisitorPresets = () => {
  const newOrReturningVisitorPresets = [
    {
      name: "NEW",
      label: "editor:segment.target.panel.label.newVisitor.name",
      value: "NEW",
      icon: <></>,
    },
    {
      name: "RETURNING",
      label: "editor:segment.target.panel.label.returningVisitor.name",
      value: "RETURNING",
      icon: <></>,
    },
  ] as const;

  return newOrReturningVisitorPresets;
};

export const getUserAgentPreset = (name: string) => {
  return getUserAgentPresets().find(
    (getUserAgentPreset) => getUserAgentPreset.name === name
  );
};

export const getReferrerPreset = (name: string) => {
  return getReferrerPresets().find(
    (getReferrerPreset) => getReferrerPreset.name === name
  );
};

export const getIsFirstPreset = (name: string) => {
  return getIsFirstPresets().find(
    (getReferrerPreset) => getReferrerPreset.name === name
  );
};

export const getNewOrReturningVisitorPreset = (name: string) => {
  return getNewOrReturningVisitorPresets().find(
    (getNewOrReturningVisitorPreset) =>
      getNewOrReturningVisitorPreset.name === name
  );
};

export const getGeolocationRegion = (
  countryValue: string,
  targetValue: string
) => {
  return geolocationTargetData[`${countryValue}`]?.find(
    (data) => data.geonameId === targetValue
  );
};

export const getCampaignTemplateData = async (templateId: string) => {
  if (templateId === "") {
    return undefined;
  }

  const templateDataRes = await getPrivateApiClient().query<
    IGetCampaignTemplateDataQuery,
    IGetCampaignTemplateDataQueryVariables
  >({
    query: GET_CAMPAIGN_TEMPLATE_DATA,
    variables: {
      id: templateId,
    },
  });

  if (templateDataRes.error) {
    handleApolloError(templateDataRes.error);
  }

  const data = templateDataRes.data.campaignTemplateData as
    | CampaignTemplateData
    | undefined;

  return data;
};

// 그래프 Y 값을 구함 (10/100/1000단위로)
export const getGraphMaxCount = (
  data: Omit<IGetInsightCountQuery, "eventCountBySite">
) => {
  let maxCount = 0;

  data.dailyInsightPvSessionCount.forEach((count) => {
    // TODO: remove optional
    if (typeof count?.viewCount === "number" && count.viewCount > maxCount) {
      maxCount = count.viewCount;
    }

    if (
      // TODO: remove optional
      typeof count?.viewerCount === "number" &&
      count.viewerCount > maxCount
    ) {
      maxCount = count.viewerCount;
    }
  });

  if (maxCount > 1000) {
    return maxCount + (1000 - (maxCount % 1000));
  } else if (maxCount > 100) {
    return maxCount + (100 - (maxCount % 100));
  }

  return maxCount + (10 - (maxCount % 10));
};

const SELECT_TEAM_KEY = "buttr.team";

export const selectTeam = (teamId: string) => {
  try {
    localStorage.setItem(SELECT_TEAM_KEY, teamId);
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const getSelectedTeam = () => {
  try {
    return localStorage.getItem(SELECT_TEAM_KEY);
  } catch (e) {
    return null;
  }
};

const SELECT_SITE_KEY = "buttr.site";

export const selectSite = (siteId: string) => {
  try {
    localStorage.setItem(SELECT_SITE_KEY, siteId);
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const removeSite = () => {
  try {
    localStorage.removeItem(SELECT_SITE_KEY);
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const getSelectedSite = () => {
  try {
    return localStorage.getItem(SELECT_SITE_KEY);
  } catch (e) {
    return null;
  }
};

/**
 * PartialCampaign 객체를 받아 ICampaignInput 객체로 변환해준다.
 *
 * @param campaign: PartialCampaign
 * @returns
 */
export const campaignToICampaignInput = (
  campaign: PartialCampaign
): ICampaignInput => {
  return {
    name: campaign?.name ?? "",
    description: campaign?.description ?? "",
    data: campaign?.data ?? {},
    display: campaign?.display ?? {},
    target: campaign?.target ?? {},
    isActive: campaign?.isActive ?? false,
    schedule: campaign?.schedule ?? {},
    type: campaign.type ?? "",
    ...((campaign.type === "BANNER" || campaign.type === "POPUP") &&
      campaign.parentPublicId && {
        parentPublicId: campaign.parentPublicId,
      }),
    ...((campaign.type === "PROMOTION" ||
      campaign.type === "FORM_EVENT" ||
      campaign.type === "FORM_SURVEY" ||
      campaign.type === "BANNER_GROUP" ||
      campaign.type === "POPUP_GROUP") &&
      campaign.meta && { meta: campaign.meta }),
  };
};

/**
 * 캠페인 타입이 INSTAGRAM_V2일 때, DataSources를 체크해서, 유효한 데이터소스(USER or PROFESSIONAL_TARGET)이 아닐 경우 True를 반환한다.
 */
export const isInvalidDataSources = ({
  type,
  dataSources,
}: {
  type: "POPUP" | "INSTAGRAM_V2";
  dataSources: DataSource[];
}) => {
  if (type === "POPUP") {
    return false;
  }

  if (!dataSources || dataSources.length < 1) {
    return true;
  }

  if (
    dataSources[0]?.sourceType === "CODENBUTTER_INSTAGRAM" &&
    !(
      dataSources[0].sourceParam.source.type === "USER" ||
      dataSources[0].sourceParam.source.type === "PROFESSIONAL_TARGET"
    )
  ) {
    return true;
  }

  return false;
};

export const getInstallHTMLCode = (
  sitePublicId: string,
  siteType?: ExternalSiteType
) => {
  if (siteType) {
    switch (siteType) {
      case "MAKESHOP":
        return `${process.env.NEXT_PUBLIC_SCRIPT_DOMAIN}/butter.js?site_id=${sitePublicId}`;
      case "CAFE24":
      case "GODOMALL":
      case "IMWEB":
      case "OOPY":
      case "SHOPBY":
      case "SHOPBY_PRO":
      case "SHOPIFY":
      case "SIXSHOP":
      case "WIX":
        break;
    }
  }

  return `<script>${getInstallJSCode(sitePublicId)}</script>`;
};

export const getInstallJSCode = (
  sitePublicId: string
) => `(function (co,de,n,but,t,e,r){!n[co]&&(n[co]=function(){
(n[co].q=n[co].q||[]).push(arguments);});e=t.createElement(but);
e.async=true;e.src=de;r=t.getElementsByTagName(but)[0];
r.parentNode.insertBefore(e, r);
})("CodenButter", "${process.env.NEXT_PUBLIC_SCRIPT_DOMAIN}/butter.js", window, "script", document);
window.CodenButter("boot", { siteId: "${sitePublicId}", auto: true });`;

export const campaignEmptyResultText = (
  type: ICampaignType
): {
  reason: string;
  description: string;
} => {
  switch (type) {
    case "POPUP":
      return {
        reason: t("emptyCampaign.reason.popup"),
        description: t("emptyCampaign.description.popup"),
      };
    case "INSTAGRAM":
    case "INSTAGRAM_V2":
      return {
        reason: "인스타그램 리스트가 비어있어요.",
        description:
          "인스타그램기능으로 빠르고 쉽게 콘텐츠를 추가하여, \n 고객과 상호작용해 보세요.",
      };
    case "BANNER_GROUP":
      return {
        reason: "리스트가 비어있어요.",
        description: "배너를 노출하려면 배너 영역을 추가해 주세요.",
      };
    case "BANNER":
      return {
        reason: "배너리스트가 비어있어요.",
        description:
          "사이트에서 가장 큰 차이를 만드는 배너, \n 지금 바로 만들어 보세요.",
      };
    case "POPUP_GROUP":
      return {
        reason: "그룹 팝업 리스트가 비어있어요.",
        description: "슬라이드 팝업을 만들어 보세요.",
      };
    case "FORM_EVENT":
      return {
        reason: "이벤트 리스트가 비어있어요.",
        description:
          "다양한 이벤트를 적재적소에 맞는 상황에 사용하여, \n 이벤트 참여를 더욱 즐겁게 해보세요.",
      };
    case "PROMOTION":
      return {
        reason: "이벤트 페이지 리스트가 비어있어요.",
        description:
          "이벤트 페이지를 생성하여 \n 고객의 시선을 모을 이벤트를 만들어보세요",
      };
    case "FORM_SURVEY":
      return {
        reason: "설문조사 리스트가 비어있어요.",
        description:
          "설문조사를 생성하여\n고객의 생각을 확인할 수 있는 페이지를 만들어보세요.",
      };
    case "ALL":
      return {
        reason: "캠페인 리스트가 비어있어요.",
        description:
          "캠페인을 추가하여, \n 시선을 모으고 고객 경험을 설계하세요!",
      };
  }
};

export const getCampaignCodeGuideProps = (
  type: CampaignType | "COMMON",
  publicId: string,
  siteType?: ExternalSiteType
): {
  title: string;
  code: string;
  steps: string[];
  alternativeLink: string;
  language: "plaintext" | "javascript";
} => {
  switch (type) {
    case "COMMON":
      return {
        title: t("wayInstallScript.title"),
        code: getInstallHTMLCode(publicId, siteType),
        steps: [
          t("wayInstallScript.step1"),
          t("wayInstallScript.step2"),
          t("wayInstallScript.step3"),
          t("wayInstallScript.step4"),
        ],
        alternativeLink: `https://${process.env.NEXT_PUBLIC_GUIDE_DOMAIN}/2adf62de-7bcd-4c11-b1c2-fc076810eecb/#94990bbe-362f-482c-83fb-db3656bb1980`,
        language: siteType === "MAKESHOP" ? "plaintext" : "javascript",
      };
    case "BANNER":
    case "BANNER_GROUP":
      return {
        title: "HTML 코드 추가 방법",
        code: `<div data-cb-embedded="banner-group" data-campaign-id="${publicId}"></div>`,
        steps: [
          "배너 <HTML> 코드를 원하는 영역에 붙여넣으세요.(<Body>와 </Body> 사이)",
          "HTML 코드를 추가한 사이트에서 배너가 노출되는지 확인해주세요.",
          "추가한 배너 크기나 세부적인 위치 조절이 필요하다면 CSS나 붙여넣은 태그 안에 스타일 속성을 이용하여 꾸며주세요. ",
        ],
        alternativeLink: `https://${process.env.NEXT_PUBLIC_GUIDE_DOMAIN}`,
        language: "javascript",
      };
    case "INSTAGRAM":
    case "INSTAGRAM_V2":
      return {
        title: "스크립트 설치 방법",
        code: `<div data-cb-embedded="instagram-v2" data-campaign-id="${publicId}"></div>`,
        steps: [
          "인스타그램 피드 <HTML> 코드를 원하는 영역에 붙여넣으세요. (<Body>와 </Body> 사이)",
          "설치한 사이트에서 인스타그램 피드가 노출되는지 확인해주세요.",
          "만약 인스타그램 크기나 세부적인 위치 조절이 필요하다면 CSS나 붙여넣은 태그 안에 스타일 속성을 이용하여 꾸며주세요.",
        ],
        alternativeLink: `https://${process.env.NEXT_PUBLIC_GUIDE_DOMAIN}/5c39fa28-3c82-481b-8c01-09bb05da6f06`,
        language: "javascript",
      };
    case "POPUP":
    case "POPUP_GROUP":
    case "PROMOTION":
    case "FORM_SURVEY":
    case "FORM_EVENT":
      return {
        title: "",
        code: "",
        steps: [],
        alternativeLink: "",
        language: "javascript",
      };
  }
};

export const getDashboardCategoryName = (
  campaignType: ISiteStatCampaignType
) => {
  switch (campaignType) {
    case "POPUP" || "INSTAGRAM":
      return "캠페인";
    case "BANNER_GROUP":
      return "배너그룹";
    case "POPUP_GROUP":
      return "그룹 팝업";
    default:
      return "캠페인";
  }
};

export const getInitialNodeDevice = (campaign: Campaign) => {
  if (
    campaign.type === "INSTAGRAM_V2" ||
    campaign.type === "INSTAGRAM" ||
    campaign.type === "FORM_EVENT" ||
    campaign.type === "FORM_SURVEY" ||
    campaign.type === "PROMOTION"
  ) {
    return "ALL";
  }

  const mobileHasContent = hasContent(
    campaign.data.documents.find((document) => document.device === "MOBILE")
  );
  const desktopHasContent = hasContent(
    campaign.data.documents.find((document) => document.device === "DESKTOP")
  );
  const allHasContent = hasContent(
    campaign.data.documents.find((document) => document.device === "ALL")
  );

  if (mobileHasContent) {
    return "MOBILE";
  }

  if (desktopHasContent) {
    return "DESKTOP";
  }

  if (allHasContent) {
    return "ALL";
  }

  return "MOBILE";
};

export const getIfValidNodeDeviceFromRouter = (
  router: NextRouter
): INodeDevice | null => {
  const nodeDevice = getParamValue<INodeDevice>(router.query, "device");
  if (
    nodeDevice === "DESKTOP" ||
    nodeDevice === "MOBILE" ||
    nodeDevice === "ALL"
  ) {
    return nodeDevice;
  }

  return null;
};

export const getKeySetFromArrayOfObject = (
  obj: Record<string, unknown>[],
  options?: {
    filter?: (key: string) => boolean;
  }
) => {
  return new Set(
    obj.flatMap(Object.keys).filter(options?.filter ?? (() => true))
  );
};

export const getUniqueKeyFromArrayOfObject = (
  obj: Record<string, unknown>[],
  options?: {
    filter?: (key: string) => boolean;
    sort?: (key1: string, key2: string) => number;
  }
) => {
  return [...getKeySetFromArrayOfObject(obj, options)].sort(
    options?.sort ??
      ((k1: string, k2: string) => (k1 === k2 ? 0 : k1 > k2 ? 1 : -1))
  );
};

export const isTempCampaign = (
  campaign: Campaign
): campaign is TempCampaign => {
  return "isTemp" in campaign;
};

export const getDefaultCampaign = ({
  campaignType,
  siteUrl,
  siteType,
  name,
  parentPublicId,
}: {
  campaignType: CampaignType;
  siteUrl?: string;
  siteType?: ExternalSiteType;
  name?: string;
  parentPublicId?: string;
}) => {
  switch (campaignType) {
    case "POPUP":
      return parentPublicId
        ? createChildPopupCampaign({
            target: getDefaultTargetRoot({ siteUrl, siteType }, false),
            name: name ?? `새 팝업 ${moment().format("YYYY/MM/DD")}`,
            isActive: false,
            type: "POPUP",
            parentPublicId,
          })
        : createPopupCampaign({
            target: getDefaultTargetRoot({ siteUrl, siteType }),
            name: name ?? `새 팝업 ${moment().format("YYYY/MM/DD")}`,
            isActive: false,
            type: "POPUP",
          });

    case "INSTAGRAM":
    case "INSTAGRAM_V2":
      return createEmbeddedInstagramCampaignV2({
        target: getDefaultTargetRoot({ siteUrl, siteType }, false),
        name: name ?? `새 인스타그램 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "INSTAGRAM_V2",
      });

    case "BANNER_GROUP":
      return createBannerGroupCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }, false),
        name: name ?? `새 배너 영역 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "BANNER_GROUP",
      });

    case "BANNER":
      return createBannerCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }, false),
        name: name ?? `새 배너 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "BANNER",
        parentPublicId,
      });

    case "POPUP_GROUP":
      return createPopupGroupCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }),
        name: name ?? `새 그룹 팝업 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "POPUP_GROUP",
      });

    case "FORM_EVENT":
      return createFormEventCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }),
        name: name ?? `새 이벤트 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "FORM_EVENT",
        meta: {
          og: {
            type: "DEFAULT",
            title: `새 이벤트 ${moment().format("YYYY/MM/DD")}`,
            description: DEFAULT_EVENT_OG_DESCRIPTION,
            imageUrl: DEFUALT_OG_IMAGE_URL,
          },
        },
      });

    case "PROMOTION":
      return createPromotionCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }),
        name: name ?? `새 이벤트 페이지 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "PROMOTION",
        meta: {
          og: {
            type: "DEFAULT",
            title: `새 이벤트 페이지 ${moment().format("YYYY/MM/DD")}`,
            description: DEFAULT_PROMOTION_OG_DESCRIPTION,
            imageUrl: DEFUALT_OG_IMAGE_URL,
          },
        },
      });

    case "FORM_SURVEY":
      return createFormSurveyCampaign({
        target: getDefaultTargetRoot({ siteUrl, siteType }),
        name: name ?? `새 설문조사 ${moment().format("YYYY/MM/DD")}`,
        isActive: false,
        type: "FORM_SURVEY",
        meta: {
          og: {
            type: "DEFAULT",
            title: `새 설문조사 ${moment().format("YYYY/MM/DD")}`,
            description: DEFAULT_SURVEY_OG_DESCRIPTION,
            imageUrl: DEFUALT_OG_IMAGE_URL,
          },
        },
      });
  }
};

export const routerPushOnCampaignListFilterChange = ({
  router,
  newFilter,
}: {
  router: NextRouter;
  newFilter: Partial<ICampaignFilterV2>;
}) => {
  const filterJSON = getParamValue(router.query, "filter");
  const filter = JSON.parse(filterJSON || "{}") as ICampaignFilterV2;

  return router.push({
    query: {
      ...router.query,
      filter: JSON.stringify({
        ...filter,
        ...newFilter,
      }),
      page: "1",
    },
  });
};

/**
 *
 * @param siteType
 * @returns siteType에 따른 가이드 링크를 반환
 */
export const getGuideLink = (siteType: string) => {
  if (siteType === "MAKESHOP") {
    return "https://guide.codenbutter.com/e5559420-6d6d-41b5-ac79-c395c811be5c";
  } else if (siteType === "GODOMALL") {
    return "https://guide.codenbutter.com/97cce928-fcf3-4c3c-978e-1f3a8a52c799";
  } else if (siteType === "IMWEB") {
    return "https://guide.codenbutter.com/27a5ee9d-003b-43d5-8bd3-3686a64b80af";
  } else if (siteType === "OOPY") {
    return "https://guide.codenbutter.com/fce0de06-c0b8-47f2-92c3-c56d49d4362f";
  } else if (siteType === "CAFE24") {
    return "https://guide.codenbutter.com/1c179edf-f8e2-46fe-a231-12e8fe0f0e6c";
  } else if (siteType === "SHOPBY") {
    return "https://guide.codenbutter.com/fe1fd301-88de-42f7-bf4a-d8cbc2db5662";
  } else if (siteType === "SHOPBY_PRO") {
    return "https://guide.codenbutter.com/72340852-2313-489a-b0f0-dc8960a7caaa";
  } else if (siteType === "SIXSHOP") {
    return "https://guide.codenbutter.com/56f45f14-4c63-4042-af56-f0f8d3b0b141";
  } else if (siteType === "SHOPIFY") {
    return "https://guide.codenbutter.com/ca9f94f4-a97a-4618-bd36-0ec6694f3189";
  }

  return "https://guide.codenbutter.com/help";
};

/**
 *
 * @param siteType
 * @returns siteType에 따른 사이트명을 반환
 */
export const getSiteTypeName = (siteType: string) => {
  if (siteType === "MAKESHOP") {
    return "메이크샵";
  } else if (siteType === "GODOMALL") {
    return "고도몰";
  } else if (siteType === "IMWEB") {
    return "아임웹";
  } else if (siteType === "OOPY") {
    return "우피";
  } else if (siteType === "CAFE24") {
    return "카페24";
  } else if (siteType === "SHOPBY") {
    return "샵바이";
  } else if (siteType === "SHOPBY_PRO") {
    return "샵바이프로";
  } else if (siteType === "SIXSHOP") {
    return "식스샵";
  } else if (siteType === "SHOPIFY") {
    return "쇼피파이";
  }

  return "";
};

/**
 *
 * @param siteType
 * @returns siteType에 따른 영상 가이드 링크를 반환
 */
export const getVideoGuideLink = (siteType: string) => {
  if (siteType === "MAKESHOP") {
    return "https://youtu.be/agS-wHEmuio";
  } else if (siteType === "GODOMALL") {
    return "https://youtu.be/-2yzHQecCt4";
  } else if (siteType === "IMWEB") {
    return "https://youtu.be/Yof8aGh6Zdg";
  } else if (siteType === "OOPY") {
    return "https://youtu.be/9Kf0pyNNNW0";
  } else if (siteType === "CAFE24") {
    return "https://youtu.be/vq2nQHt87Eo";
  } else if (siteType === "SHOPBY") {
    return "https://youtu.be/-2yzHQecCt4";
  } else if (siteType === "SHOPBY_PRO") {
    return "https://youtu.be/-2yzHQecCt4";
  } else if (siteType === "SIXSHOP") {
    return "https://youtu.be/7hLJNoZB-Xc";
  } else if (siteType === "SHOPIFY") {
    return "https://youtu.be/zfwHu45rF5E";
  }

  return "";
};

export const getNumberOfTargets = (target: CampaignTargetType): number => {
  const value = target.type === "ROOT" ? target.value.value : target.value;
  let sum = 0;

  if (Array.isArray(value)) {
    for (const v of value) {
      sum += typeof v === "string" ? 1 : getNumberOfTargets(v);
    }
  } else {
    sum += 1;
  }

  return sum;
};
